import React, { useState, useEffect, useRef } from 'react';
import './style.scss';
import PropTypes from 'prop-types';

function Alert(props) {
    const {
      onDismiss = () => {},
      messageType
    } = props;

    const [isVisible, setIsVisible] = useState(true);
    const alertRef = useRef(null);

    let alertClass = '';
    let ariaLabel = '';

    switch(messageType) {
      case 'success':
        alertClass = 'alert alert-success';
        ariaLabel = 'Success Alert';
        break;
      case 'warning':
        alertClass = 'alert alert-warning';
        ariaLabel = 'Warning Alert';
        break;
      case 'error':
        alertClass = 'alert alert-error';
        ariaLabel = 'Error Alert';
        break;
      default:
        alertClass = 'alert';
        ariaLabel = 'Informational Alert';
    }

    useEffect(() => {
        if (isVisible) {
            alertRef.current.focus();
        }
    }, [isVisible]);

    const handleDismiss = () => {
        setIsVisible(false);
        onDismiss();
    };
    
    return isVisible ? (
        <div 
            className={alertClass}
            role="alert" 
            tabIndex={-1} 
            ref={alertRef} 
            aria-label="Informational Alert"
        >
            <p>
                {props.children}
            </p>
            <button 
                className="dismiss-button" 
                onClick={handleDismiss} 
                aria-label={ariaLabel}
            >
                X
            </button>
        </div>
    ) : null;
}

Alert.propTypes = {
    onDismiss: PropTypes.func,
    children: PropTypes.node.isRequired
};

export default Alert;
